/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { IUserSettings } from '../../../core/models';
import { EHealthCheckRequestState, IDeviceHealthCheckHistory } from '../../models';

@Component({
  selector: 'fm-device-health-check-history',
  templateUrl: './device-health-check-history.component.html',
  styleUrls: ['./device-health-check-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeviceHealthCheckHistoryComponent {
  @Input()
  history: IDeviceHealthCheckHistory[];
  @Input()
  historyLoading: boolean;
  @Input()
  userSettings: IUserSettings;
  @Input()
  vehicleId: number;

  EHealthCheckRequestState = EHealthCheckRequestState;

  constructor(@Inject(DOCUMENT) private readonly _document: Document) {}

  viewAllHistory() {
    const userLanguage = this.userSettings?.Language ?? this._document.defaultView?.navigator?.language ?? 'en-US';
    const vehicleSiteUrl = `${environment.config.legacyBaseUrl}/${userLanguage}/admin/vehicles-live/${this.vehicleId}/vehicle-device-health-check`;
    this._document.defaultView?.open(vehicleSiteUrl, '_blank');
  }
}
